import { useCallback, useState } from 'react';

export const useSpecialPricingRule = () => {
  const [editModalState, setEditModalState] = useState<boolean>(false);

  const onEditModalStateChange = useCallback(() => {
    setEditModalState((prevState) => !prevState);
  }, []);

  return {
    editModalState,
    onEditModalStateChange,
  };
};
